import { Platform } from 'react-native';
import useLinking from './useLinking';
import { isNative } from '~global/screens';
import { downloadLink } from '~global/constants';
//
const { appStore, playStore } = downloadLink;

const useDownloadLink = () => {
  let url = Platform.OS == 'ios' ? appStore : playStore;
  const userAgent = isNative
    ? ''
    : navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
    url = appStore;
  }
  if (url && !isNative) {
    window.dataLayer.push({
      event: 'Download Lilla',
      downloadLink: url,
    });
  }
  //
  return useLinking(url);
};

export default useDownloadLink;
